var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-screen-panel',{attrs:{"show-on-mobile":_vm.showOnMobile}},[_c('full-screen-panel-content',{staticClass:"p-8 pr-0 pt-8"},[_c('div',{class:['flex flex-col flex-1 p-6 bg-white shadow-3xl overflow-y-auto overflow-x-hidden h-full', _vm.classList]},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }